<!-- Chat Panel Container -->
<div class="chat-panel-container">
  <!-- Chat Header -->
  <div class="chat-header">
    <div class="bot-avatar">
      <img src="assets/images/sparkle.png" alt="AI" class="icon-image" />
    </div>
    <div class="header-content">
      <p class="header-title">{{ headerTitle }}</p>
      <p class="header-subtitle">{{ headerSubtitle }}</p>
    </div>
    <button *ngIf="mobileOpen" type="button" (click)="mobileClose.emit()" class="close-button">
      <span class="material-icon">✕</span>
    </button>
  </div>

  <!-- Messages -->
  <div #messagesContainer class="messages-container">
    <div *ngFor="let m of messages" class="message-row" [class.user-message]="m.role === 'user'" [class.assistant-message]="m.role === 'assistant'">
      <!-- Bot avatar -->
      <div *ngIf="m.role === 'assistant'" class="bot-avatar-small">
        <img src="assets/images/BotIcon.png" alt="AI" class="icon-image" />
      </div>

      <!-- Assistant bubble -->
      <ng-container *ngIf="m.role === 'assistant'">
        <div class="message-bubble assistant-bubble" [class.error]="m.isError">
          <!-- Error message styling -->
          <p *ngIf="m.isError" class="error-title">⚠️ Error:</p>

          <!-- Answer text -->
          <p *ngFor="let line of formatMsg(m.content)">{{ line }}</p>

          <!-- Results table (if available) -->
          <div *ngIf="m.results && m.results.length > 0" class="results-table">
            <p class="results-header">Results:</p>
            <table>
              <thead>
                <tr>
                  <th *ngFor="let key of getObjectKeys(m.results[0])">{{ key }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of m.results">
                  <td *ngFor="let key of getObjectKeys(m.results[0])">{{ row[key] }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </ng-container>

      <!-- User bubble -->
      <ng-container *ngIf="m.role === 'user'">
        <div class="message-bubble user-bubble">
          {{ m.content }}
        </div>
      </ng-container>

      <!-- User avatar -->
      <div *ngIf="m.role === 'user'" class="user-avatar">
        <img src="assets/images/chatUser.png" alt="User" class="user-icon" />
      </div>
    </div>

    <!-- Empty state message (shown only if truly no messages AND not loading) -->
    <div *ngIf="!chatLoading && messages.length === 0" class="empty-state">
      <span class="material-icon">🎤</span>
      <p class="empty-title">No Messages</p>
      <p class="empty-text">Start chatting below to continue this conversation.</p>
    </div>

    <!-- Loading dots with status -->
    <div *ngIf="chatLoading" class="loading-container">
      <!-- Bot avatar + loading spinner -->
      <div class="message-row assistant-message">
        <div class="bot-avatar-small">
          <img src="assets/images/BotIcon.png" alt="AI" class="icon-image" />
        </div>
        <div class="loading-bubble">
          <div *ngFor="let j of [0,1,2]" class="loading-dot"></div>
        </div>
      </div>
    </div>
  </div>

  <!-- Input form -->
  <form class="chat-input-form" (submit)="$event.preventDefault(); sendMessage.emit()">
    <div class="input-wrapper">
      <input type="text" [value]="chatDraft" (input)="onDraftChange($any($event.target).value)"
             name="chatInput"
             placeholder="Ask a question"
             (keydown.enter)="$event.preventDefault(); sendMessage.emit()" />
      <button type="submit" [disabled]="chatLoading || !chatDraft.trim()"
              class="send-button" aria-label="Send">
        <span class="material-icon">➤</span>
      </button>
    </div>
  </form>
</div>
